import { render, staticRenderFns } from "./ArticleForNewOrder.vue?vue&type=template&id=1978d470&scoped=true"
import script from "./ArticleForNewOrder.vue?vue&type=script&lang=js"
export * from "./ArticleForNewOrder.vue?vue&type=script&lang=js"
import style0 from "./ArticleForNewOrder.vue?vue&type=style&index=0&id=1978d470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1978d470",
  null
  
)

export default component.exports